import React from 'react';
import 'react-data-grid/lib/styles.css';
import { Card, CardBody, Col, Container, FormGroup, Row } from 'reactstrap';
import useAuth from '../../../hooks/useAuth';

export default function DetailedCompletionsViewOptions() {
    const auth = useAuth();

    const isKy = auth?.auth.isKy;
    const isCa = auth?.auth.isCa;
    const isWa = auth?.auth.isWa;

    const detailData = [
        { id: "1", value: "Full Name" },
        { id: "2", value: "Course/Activity" },
        { id: "3", value: "Session Name" },
        { id: "4", value: "Event Name" },
        { id: "5", value: "Type" },
        { id: "6", value: "Category" },
        { id: "7", value: "Training Hours" },
        { id: "8", value: "Completion Date" },
        { id: "9", value: "Start Time" },
        { id: "10", value: "End Time" },
        { id: "11", value: "ISO Code" },
        { id: "12", value: "Kentucky Code" },
        { id: "13", value: "CAL-JAC Code" },
        { id: "14", value: "WSRB Category" },
        { id: "15", value: "Other Training Codes" },
        { id: "16", value: "Score" },
        { id: "17", value: "Location" },
        { id: "18", value: "Description" },
        { id: "19", value: "Internal Instructors" },
        { id: "20", value: "External Instructors" },
    ]

    if (!isKy) {
        const kyIdx = detailData.findIndex(obj => obj.value === "Kentucky Code");
        detailData.splice(kyIdx, 1);
    }
    if (!isCa) {
        const caIdx = detailData.findIndex(obj => obj.value === "CAL-JAC Code");
        detailData.splice(caIdx, 1);
    }
    if (!isWa) {
        const waIdx = detailData.findIndex(obj => obj.value === "WSRB Category");
        detailData.splice(waIdx, 1);
    }

    const userData = [
        { id: "21", value: "Department" },
        { id: "22", value: "Personnel ID" },
        { id: "23", value: "Rank" },
        { id: "24", value: "Shift" },
        { id: "25", value: "Station" },
        { id: "26", value: "Division" },
        { id: "27", value: "Battalion" },
        { id: "28", value: "Company" },
        { id: "29", value: "Platoon" },
        { id: "30", value: "Bureau" },
        { id: "31", value: "EMS Certification" },
    ];

    return (
        <Container>
            <h1>Report Fields</h1>
            <FormGroup>
                <Card>
                    <CardBody>
                        <Row>
                            <Col xs="6">
                                <div>Detail Fields</div>
                            </Col>
                            <Col xs="6">
                                {detailData.map((item, index) => {
                                    return (
                                        <div key={item.id} className="checkbox-container">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="options"
                                                    value={item.value}
                                                    defaultChecked={true}
                                                    disabled={true}
                                                />
                                                &nbsp;{item.value}
                                            </label>
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </FormGroup>
            <FormGroup>
                <Card>
                    <CardBody>
                        <Row>
                            <Col xs="6">
                                <div>User Fields</div>
                            </Col>
                            <Col xs="6">
                                {userData.map((item, index) => {
                                    return (
                                        <div key={item.id} className="checkbox-container">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="options"
                                                    value={item.value}
                                                    defaultChecked={true}
                                                    disabled={true}
                                                />
                                                &nbsp;{item.value}
                                            </label>
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </FormGroup>
        </Container>
    );
}